import { takeEvery, takeLatest, fork, put, all, call, select } from "redux-saga/effects";
import {
    getTransactionsSuccessful,
    getTransactionsError,
    getFilteredTransactionsSuccessful,
    getFilteredTransactionsError,
    createInvoiceError,
    createInvoiceSuccess,
    getInvoicesError,
    getInvoicesSuccessful,
    setInvoicingQuery,
    setInvoiceQuery
} from "./actions";
import InvoiceService from "./service";
import { InvoicingActionTypes } from "./actionTypes";

// Selectors to get the invoicing query states from the Redux store.
export const getInvoicingQuery = state => state.Invoicing.query;
export const getInvoiceQuery = state => state.Invoices.query;

function* getAllTransactions({payload}) {
    try {
        // Get the current query from the Redux store.
        const storedQuery = yield select(getInvoicingQuery);
        // The payload from the action can override the stored query for this specific call.
        const finalPayload = { ...storedQuery, ...payload };
        const response = yield call(InvoiceService.getTransactions, finalPayload);
        yield put(getTransactionsSuccessful(response));
        yield put(setInvoicingQuery(finalPayload));
    } catch (error) {
        yield put(getTransactionsError(error));
    }
}

function* getAllInvoices({payload}) {
    try {
        // Get the current query from the Redux store.
        const storedQuery = yield select(getInvoiceQuery);
        // The payload from the action can override the stored query for this specific call.
        const finalPayload = { ...storedQuery, ...payload };
        const response = yield call(InvoiceService.getInvoices, finalPayload);
        yield put(getInvoicesSuccessful(response));
        yield put(setInvoiceQuery(finalPayload));
    } catch (error) {
        yield put(getInvoicesError(error));
    }
}

export function* watchGetInvoicing() {
    yield takeLatest(InvoicingActionTypes.INVOICING_LIST_GET, getAllTransactions);
}


export function* watchGetInvoices() {
    yield takeLatest(InvoicingActionTypes.INVOICE_LIST_GET, getAllInvoices);
}


function* getFiltered({payload}) {
    try {
        const response = yield call(InvoiceService.getFilteredTransactions, { professionalID: payload });
        const rsp = getFilteredTransactionsSuccessful(response);
        yield put(rsp);
    } catch (error) {
        yield put(getFilteredTransactionsError(error));
    }
}
export function* watchFilterInvoicing() {
    yield takeEvery(InvoicingActionTypes.INVOICING_GET_FILTERED, getFiltered);
}


function* createInvoiceSaga({payload}) {
    try {
        const response = yield call(InvoiceService.createInvoice, { transactions: payload });
        const rsp = createInvoiceSuccess(response);
        yield put(rsp);
    } catch (error) {
        yield put(createInvoiceError(error));
    }
}
export function* watchCreateInvoice() {
    yield takeEvery(InvoicingActionTypes.INVOICING_CREATE, createInvoiceSaga);
}



function* invoicingSaga() {
    yield all([
        fork(watchGetInvoicing),
        fork(watchFilterInvoicing),
        fork(watchCreateInvoice),
        fork(watchGetInvoices),
    ]);
}



export default invoicingSaga;
